module.exports = __webpack_public_path__ + "assets/images/vcr_officeBuilding-04.865be3c3c7be24ac147765a4f86ae6c1.svg";